import { render, staticRenderFns } from "./ArchivedMilestones.vue?vue&type=template&id=32a8f84a&scoped=true&"
import script from "./ArchivedMilestones.vue?vue&type=script&lang=js&"
export * from "./ArchivedMilestones.vue?vue&type=script&lang=js&"
import style0 from "./ArchivedMilestones.vue?vue&type=style&index=0&id=32a8f84a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a8f84a",
  null
  
)

export default component.exports